import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthenticationService} from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AppuserGuard  {
  constructor(private router: Router, private authenticationService: AuthenticationService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authenticationService.currentUserSubject.pipe(map(appuser => {
      switch (appuser.user_type) {
        case 'employee':
          this.router.navigate(['dashboard']);
          break;
        case 'hv':
          this.router.navigate(['hv']);
          break;
        case 'customer':
          return true;
          break;
        default:
          this.router.navigate(['login'], {queryParams: {returnUrl: state.url}});
          break;
      }
      return false;
    }));
  }

}
